import React, { useEffect, useState } from 'react'
import { faProcedures, faCrutch, faWheelchair, faHeadSideCough, faPlusSquare, faAmbulance, faLungs, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlockIcon from '@material-ui/icons/Block';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SaveIcon from '@material-ui/icons/Save';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import FormEspecialReq from '../../containers/Admissions/AddAdmission/components/FormEspecialReq';

const EditSpecialRequerimets = ({ reqEspProps, idAdmision }) => {
    const [edit_reqEspeciales, setEdit_reqEspeciales] = useState(false);
    const [disabledForm, setDisabledForm] = useState(false);
    const [disableEspReqForm, setDisableEspReqForm] = useState(false);
    const [id_admision, setId_admision] = useState(0);
    const [requerimientos_especiales, setRequerimientos_especiales] = useState({
        hospitalizado: false,
        sillas: false,
        muletas: false,
        sintomas_respiratorios: false,
        oxigeno: false,
        camilla: false,
        ambulancia: false,
        ninguno: false,
        otro: false,
        otroReq: ''
    });

    useEffect(() => {
        if (reqEspProps !== undefined && reqEspProps !== null) {
            setRequerimientos_especiales(reqEspProps);
            if(reqEspProps.ninguno === true){
                setDisableEspReqForm(true)
            }
        }
        if (idAdmision !== undefined && idAdmision !== null) {
            setId_admision(idAdmision);
        }
    }, [])


    const setReqHospitalizado = (chkHospitalizad) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, hospitalizado: chkHospitalizad } });
    }

    const setReqSillas = (chkSillas) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, sillas: chkSillas } });
    }

    const setReqMuletas = (chkMuletas) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, muletas: chkMuletas } });
    }

    const setReqSintomas = (chkSintoma) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, sintomas_respiratorios: chkSintoma } });
    }

    const setReqOxigeno = (chkOxigeno) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, oxigeno: chkOxigeno } });
    }

    const setReqCamilla = (chkCamilla) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, camilla: chkCamilla } });
    }

    const setReqAmbulancia = (chkAmbulancia) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, ambulancia: chkAmbulancia } });
    }

    const setReqNinguno = (chkNinguno) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, ninguno: chkNinguno } });
        if (chkNinguno == false) {
            setDisableEspReqForm(false);
        } else {
            setDisableEspReqForm(true);
            setRequerimientos_especiales({
                hospitalizado: false,
                sillas: false,
                muletas: false,
                sintomas_respiratorios: false,
                oxigeno: false,
                camilla: false,
                ambulancia: false,
                ninguno: chkNinguno,
                otro: false,
                otroReq: ''
            });
        }
    }

    const setReqOtro = (chkOtro) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, otro: chkOtro } });
        
    }

    const setReqOtroReq = (chkOtroReq) => {
        setRequerimientos_especiales(prevState => { return { ...prevState, otroReq: chkOtroReq } });
    }

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', padding: '0.5em 0.5em' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0.5em 0.5em' }}>
                    <div>
                        <Tooltip title="Editar Requerimientos Especiales">
                            <IconButton aria-label="launch" color="inherit" style={{ padding: 2, backgroundColor: '#55e5bb', width: '1.2em', height: '1.2em' }}
                                onClick={() => {
                                    setEdit_reqEspeciales(!edit_reqEspeciales)
                                }}
                            >
                                <EditOutlinedIcon style={{ color: '#153365' }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div>
                        <p style={{ color: '#153365', padding: '0em 0.25em' }}>Req. Especiales:</p>
                        {
                            requerimientos_especiales.hospitalizado !== false && requerimientos_especiales.hospitalizado !== undefined ?
                                <Tooltip title="Hospitalizado">
                                    <IconButton style={{ padding: 0, }}>
                                        <FontAwesomeIcon icon={faPlusSquare} style={{ margin: '0px 5px 0px 5px', color: '#1086e0', width: '15px' }} />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {
                            requerimientos_especiales.sillas !== false && requerimientos_especiales.sillas !== undefined ?
                                <Tooltip title="Sillas de ruedas">
                                    <IconButton style={{ padding: 0, }}>
                                        <FontAwesomeIcon icon={faWheelchair} style={{ margin: '0px 5px 0px 5px', width: '15px', color: '#1086e0' }} />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {
                            requerimientos_especiales.sintomas_respiratorios !== false && requerimientos_especiales.sintomas_respiratorios !== undefined ?
                                <Tooltip title="Sintomas respitarios (Covid)">
                                    <IconButton style={{ padding: 0, }}>
                                        <FontAwesomeIcon icon={faHeadSideCough} style={{ margin: '0px 5px 0px 5px', width: '15px', color: '#1086e0' }} />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {
                            requerimientos_especiales.oxigeno !== false && requerimientos_especiales.oxigeno !== undefined ?
                                <Tooltip title="Oxigeno">
                                    <IconButton style={{ padding: 0, }}>
                                        <FontAwesomeIcon icon={faLungs} style={{ margin: '0px 5px 0px 5px', width: '15px', color: '#1086e0' }} />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {
                            requerimientos_especiales.camilla !== false && requerimientos_especiales.camilla !== undefined ?
                                <Tooltip title="Camilla">
                                    <IconButton style={{ padding: 0, }}>
                                        <FontAwesomeIcon icon={faProcedures} style={{ margin: '0px 5px 0px 5px', width: '15px', color: '#1086e0' }} />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {
                            requerimientos_especiales.ambulancia !== false && requerimientos_especiales.ambulancia !== undefined ?
                                <Tooltip title="Ambulancia">
                                    <IconButton style={{ padding: 0, }}>
                                        <FontAwesomeIcon icon={faAmbulance} style={{ margin: '0px 5px 0px 5px', width: '15px', color: '#1086e0' }} />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {
                            requerimientos_especiales.ninguno !== false && requerimientos_especiales.ninguno !== undefined ?
                                <>
                                    <div>
                                        <p style={{ padding: '0em 0.25em', color: '#1086e0' }}>Ninguno</p>
                                    </div>
                                </>
                                : null
                        }
                        {
                            requerimientos_especiales.otro !== false && requerimientos_especiales.otro !== undefined ?
                                <>
                                    <div>
                                        <p style={{ padding: '0em 0.25em', color: '#1086e0' }}>{ requerimientos_especiales.otroReq }</p>
                                    </div>
                                </>
                                : null
                        }
                    </div>
                </div>

            </div>
            {
                edit_reqEspeciales ?
                    <FormEspecialReq
                        setReqHospitalizado={setReqHospitalizado}
                        setReqSillas={setReqSillas}
                        setReqMuletas={setReqMuletas}
                        setReqSintomas={setReqSintomas}
                        setReqOxigeno={setReqOxigeno}
                        setReqCamilla={setReqCamilla}
                        setReqAmbulancia={setReqAmbulancia}
                        setReqNinguno={setReqNinguno}
                        setReqOtro={setReqOtro}
                        setReqOtroReq={setReqOtroReq}
                        selectedItems={requerimientos_especiales}
                        disabledForm={disabledForm}
                        disableEspReqForm={disableEspReqForm}
                        setDisableEspReqForm={setDisableEspReqForm}
                        id_admision={id_admision}
                        editReqEsp={edit_reqEspeciales}
                        setEditReqEsp={setEdit_reqEspeciales} />
                    : null
            }
        </div>
    )
}

export default EditSpecialRequerimets